// Deterministic noise function for sparkline charts (avoids re-randomizing on re-render)
export function seededNoise(seed: string, index: number): number {
  let hash = 0;
  const str = `${seed}-${index}`;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return ((Math.abs(hash) % 1000) / 1000 - 0.5);
}
